import { localized } from "@msuite/ui/localization";
import { createColumnHelper, createRowActions } from "@msuite/ui/table";
import { Tag } from "@msuite/ui/tag";
import { guardString } from "@msuite/utils/strings";
import type { ReturnCarrierReconciliationListItem } from "@msuite/utils/types";
import { RowActions } from "./row-actions";

const columnHelper = createColumnHelper<ReturnCarrierReconciliationListItem>();

/**
 * One row per carrier type the project was ever sent or has returned, in the same shape the
 * article account takes — including the three outcomes of `outstandingQuantity`, where below zero
 * means a site handed back somebody else's pallets.
 */
export const returnCarrierReconciliationTableColumns = [
	columnHelper.accessor("loadCarrierName", {
		id: "loadCarrierName",
		header: localized("general.name"),
		cell: (cell) => guardString(cell.getValue()),
	}),
	columnHelper.accessor("shippedQuantity", {
		id: "shippedQuantity",
		header: localized("stock.return_shipped"),
		cell: (cell) => String(cell.getValue()),
	}),
	columnHelper.accessor("returnedQuantity", {
		id: "returnedQuantity",
		header: localized("stock.return_returned"),
		cell: (cell) => String(cell.getValue()),
	}),
	columnHelper.accessor("outstandingQuantity", {
		id: "outstandingQuantity",
		header: localized("stock.return_outstanding"),
		cell: (cell) => {
			const outstanding = cell.getValue();
			if (outstanding === 0) {
				return (
					<Tag
						variant="plain"
						color="emerald"
					>
						{localized("stock.return_net_zero")}
					</Tag>
				);
			}
			if (outstanding < 0) {
				return (
					<Tag
						variant="plain"
						color="amber"
					>
						{localized("stock.return_over_returned")}
					</Tag>
				);
			}
			return String(outstanding);
		},
	}),
	createRowActions(RowActions),
];
